module.exports = __webpack_public_path__ + "static/img/15.b0931b6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/3/1/sp/15.png
// module id = /epU
// module chunks = 0